import React, { Component } from "react";
import BootstrapTable from "@partseye/react-bootstrap-table-next";
import "@partseye/react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "@partseye/react-bootstrap-table2-filter/dist/react-bootstrap-table2-filter.min.css";
import ModalWindow from "./ModalWindow";
import { formatCurrencyAmount } from "./culture";

export default class PackingListModal extends Component {

    constructor(props) {

        super(props);

        if (this.props.inventoryPK !== null && this.props.returnPK !== null) {

            this.getPackingListData(
                this.props.inventoryPK,
                this.props.returnPK
            );

        }

        this.state = {
            "packingList": null,
            "loading": false,
            "printing": null,
            "dataError": false
        };

    }

    getPackingListData(invPK, returnPK) {

        fetch(`/api/Reports/GetPackingListDetails/${invPK}/${returnPK}`).
            then((response) => response.json()).
            then((data) => {

                this.setState({
                    "packingList": data,
                    "loading": false,
                    "dataError": false
                });

            }).
            catch((error) => {

                this.setState({ "dataError": true });

            });

    }


    print() {

        this.setState({ "printing": true });

        // Getting divs to be used
        const maindiv = document.getElementById("reports"),
            modal = document.getElementById("PackingList-Printable"),
            cloned = modal.cloneNode(true);

        // Hiding main reports div so it does not show up in modal print
        maindiv.style.visibility = "hidden";
        maindiv.style.display = "none";

        // Cloning model div and showing it on screen
        const section = document.createElement("div");
        section.id = "packinglist-print";
        document.body.appendChild(section);
        section.innerHTML = "";
        section.appendChild(cloned);

        setTimeout(
            () => {

                window.print();
                this.setState({ "printing": false });

                // Un-hiding main reports div
                maindiv.style.visibility = "";
                $("#reports").css({ "display": "" });
                $("#packinglist-print").remove();

            },
            500
        );

    }

    render() {

        const { packingList } = this.state;
        let modalBody,
            oemLogo = null,
            scrapTotal = 0,
            restrictedTotal = 0,
            showReturnList = false,
            showScrapList = false,
            showRestrictedList = false;
        const oemLogoPath = "images/oemLogos/";

        // Check if Isuzu US or CA
        const makeCode = this.props.sessionInfo?.selected?.MakeCode;
        const isIsuzuUSCA = makeCode === "IS" || makeCode === "IC";

        // Determine which footnote to use (EN for IS, FR for IC)
        const footnoteText = this.props.pageText.returnCreditDisclaimerFootnote;

        if (packingList !== null) {
            let restrictedList = packingList.returnLines.filter(function (item) {
                return item.isReturnable == false && item.returnCode === "S";
            });

            showRestrictedList = restrictedList.length > 0;
            restrictedTotal = formatCurrencyAmount(restrictedList.reduce(
                (sum, key) => sum + key.lineTotal,
                0
            ), this.props.sessionInfo.selected, true, true);
            // Getting full total of all scrap parts
            scrapTotal = formatCurrencyAmount(packingList.scrapLines.reduce(
                (sum, key) => sum + key.lineTotal,
                0
            ), this.props.sessionInfo.selected, true, true);

            // Determining whether or not to show tables/sections based on list count and OEM flag
            showReturnList = packingList.returnLines.length > 0;
            showScrapList = packingList.scrapLines.length > 0 && this.props.showPackingList;

            oemLogo = oemLogoPath + packingList.oemLogoInformation.fileName;


            const AmountTotal = packingList.returnLines.reduce((a, b) => a + (b.dealerReturned * b.unitPrice || 0), 0).toFixed(2);


            // --- IRIS Return Packing Slip columns ---
            const returnTableColumns = [
                {
                    "dataField": "partNumber",
                    "text": "Isuzu Part #",
                    "sort": true
                },
                {
                    "dataField": "alternatePartNumber",
                    "text": "GM Part #",
                    "sort": true
                },
                {
                    "dataField": "description",
                    "text": "Description",
                    "sort": true
                },
                {
                    "dataField": "bin",
                    "text": "Bin",
                    "sort": true
                },
                // Only show Dealer Net + Ext Cost for non-Isuzu US/CA
                ...(!isIsuzuUSCA ? [
                    {
                        "dataField": "unitPrice",
                        "text": this.props.pageText.dealerNet,
                        "sort": true,
                        "formatter": (val) => (val === null ? "" : formatCurrencyAmount(val, this.props.sessionInfo.selected, true, true))
                    }
                ] : []),
                {
                    "dataField": "dealerReturned",
                    "text": "Qty Returned",
                    "sort": true,
                },
                ...(!isIsuzuUSCA ? [
                    {
                        "dataField": 'extCost',
                        "text": this.props.pageText.extCost,
                        "sort": true,
                        "formatter": (val, row, rowIndex) => {
                            return <div>${(row.dealerReturned * row.unitPrice).toFixed(2)}</div>;
                        },
                    }
                ] : [])
            ];

            // --- IRIS Scrap Authorization columns ---
            const scrapTableColumns = [
                {
                    "dataField": "partNumber",
                    "text": "Isuzu Part #",
                    "sort": true
                },
                {
                    "dataField": "alternatePartNumber",
                    "text": "GM Part #",
                    "sort": true
                },
                {
                    "dataField": "description",
                    "text": "Description",
                    "sort": true
                },
                {
                    "dataField": "bin",
                    "text": "Bin",
                    "sort": true
                },
                {
                    "dataField": "dealerReturned",
                    "text": "Scrap Qty",
                    "sort": true
                },
                // Only show Per Unit Cost + Scrap Amount for non-Isuzu US/CA
                ...(!isIsuzuUSCA ? [
                    {
                        "dataField": "unitPrice",
                        "text": "Per UnitCost",
                        "sort": true,
                        "formatter": (val) => (val === null ? "" : formatCurrencyAmount(val, this.props.sessionInfo.selected, true, true))
                    },
                    {
                        "dataField": "lineTotal",
                        "text": "Scrap Amount",
                        "sort": true,
                        "formatter": (val) => (val === null ? "" : formatCurrencyAmount(val, this.props.sessionInfo.selected, true, true))
                    }
                ] : [])
            ];

            // --- IRIS Restricted Return columns ---
            const restrictedColumns = [
                {
                    "dataField": "partNumber",
                    "text": "Isuzu Part #",
                    "sort": true
                },
                {
                    "dataField": "alternatePartNumber",
                    "text": "GM Part #",
                    "sort": true
                },
                {
                    "dataField": "description",
                    "text": "Description",
                    "sort": true
                },
                {
                    "dataField": "bin",
                    "text": "Bin",
                    "sort": true
                },
                {
                    "dataField": "dealerReturned",
                    "text": "Qty Returned",
                    "sort": true
                },
                // Only show Per Unit Cost + Ext Cost for non-Isuzu US/CA
                ...(!isIsuzuUSCA ? [
                    {
                        "dataField": "unitPrice",
                        "text": "Per UnitCost",
                        "sort": true,
                        "formatter": (val) => (val === null ? "" : formatCurrencyAmount(val, this.props.sessionInfo.selected, true, true))
                    },
                    {
                        "dataField": "lineTotal",
                        "text": this.props.pageText.extCost,
                        "sort": true,
                        "formatter": (val) => (val === null ? "" : formatCurrencyAmount(val, this.props.sessionInfo.selected, true, true))
                    }
                ] : [])
            ];

            modalBody =
                (<div id="PackingList-Printable" >
                    <div className="PackingList-PackingSlipInfo">
                        <div className="container">
                            {showReturnList
                                ?

                                <div className="row">
                                    <div className="col-sm-12">
                                        <h4 className="text-center">
                                            {this.props.pageText.packingListModalIrisReturnPackingSlipTableHeader}
                                        </h4>
                                    </div>
                                <div className="col-sm-6 PackingList-AddressInfo">

                                        <div className="row">
                                            <div className="col-sm-6 text-label">
                                                <p className="text-right">
                                                    <strong>{this.props.pageText.packingListModalPackingSlipLabel}</strong>
                                                </p>
                                            </div>
                                            <div className="col-sm-6 text-values">
                                                <p className="text-left">
                                                    {packingList.packingSlipNumber}
                                                </p>
                                            </div>
                                        </div>

                                        <div className="row">
                                            <div className="col-sm-6 text-label">
                                                <p className="text-right">
                                                    <strong>{this.props.pageText.packingListModalDealerCodeLabel}</strong>
                                                </p>
                                            </div>
                                            <div className="col-sm-6 text-values">
                                                <p className="text-left">
                                                    {packingList.dealerCode}
                                                </p>
                                            </div>
                                        </div>

                                        <div className="row">
                                            <div className="col-sm-6 text-label">
                                                <p className="text-right">
                                                    <strong>{this.props.pageText.packingListModalAddressLabel}</strong>
                                                </p>
                                            </div>
                                            <div className="col-sm-6 text-left text-values PackingList-Address">
                                                <p>
                                                    {packingList.inventoryTitle}
                                                </p>
                                                <p>
                                                    {packingList.address.addressLineOne}
                                                </p>
                                                <p>
                                                    {packingList.address.city}
,{packingList.address.stateCode}
,{packingList.address.postalCode}
                                                </p>
                                                <p>
                                                    <strong>
                                                        {packingList.address.phone}
                                                    </strong>
                                                </p>
                                            </div>
                                        </div>

                                    </div>

                                    <div className="col-sm-6 data-is">
                                        <div className="row text-right">
                                            <div className="col-sm-12">
                                                <i className="material-icons print text-right"
                                                    onClick={() => this.print()}>
                                                    print
</i>
                                            </div>
                                        </div>

                                        <div className="row text-right oem-logo">
                                            <div className="col-sm-12">
                                                <img className="float-right" key="oem-logo" src={oemLogo} title={packingList.oemLogoInformation.alternateText} />
                                            </div>
                                        </div>

                                        <div className="row text-right">
                                            <div className="col-sm-12 text-label">
                                                <span>
                                                    <strong>{this.props.pageText.packingListModalDealerReferenceLabel}</strong>{packingList.reference}</span>

                                            </div>
                                        </div>
                                    </div>


                                </div>
                                : null}
                        </div>
                    </div>

                    {/* IRIS Return Packing Slip Table */}
                    {showReturnList
                        ? <div id="PackingListTable">

                            <h4 className="text-center">
                                {this.props.pageText.packingListModalReturnPackingSlipTableHeader}
                            </h4>
                            <BootstrapTable
                                bootstrap4
                                columns={returnTableColumns}
                                condensed
                                data={packingList.returnLines}
                                headerClasses="thead-light"
                                keyField='partNumber'
                                striped
                            />
                        </div>
                        : null}

                    {/* Total Return Amount - hide for IS/IC */}
                    {!isIsuzuUSCA && (
                        <div className="PackingList-ScrapTotal">
                            <div className="container">
                                <div className="row">
                                    <div className="col-sm-12 text-right">
                                        <p className="packingfooter-bold">
                                            {this.props.pageText.packingReturnListTotalAmountLabel}
                                            {':'}
                                        {formatCurrencyAmount(AmountTotal, this.props.sessionInfo.selected, true, true)}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                    {/* Isuzu US/CA footnote for Return slip */}
                    {isIsuzuUSCA && showReturnList && (
                        <div className="PackingList-ScrapTotal">
                            <div className="container">
                                <div className="row">
                                    <div className="col-sm-12 text-left">
                                        <p className="returnFooterText">
                                            {footnoteText}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                    <div className="PackingList-ScrapTotal">
                        <div className="container">
                            <div className="row">
                                <div className="col-sm-12 text-center" >
                                    <span className="packing-footer-one-bold">{this.props.pageText.packingReturnListFooterOneLabel}</span><br />
                                    <span className="packingfooter-bold">{this.props.pageText.packingReturnListFooterTwoLabel}</span>
                                </div>
                            </div>
                        </div>
                    </div>


                    <hr/>


                {/* IRIS Restricted Return Packing Slip */}
                {showRestrictedList
                    ? <div className="PackingList-ScrapListSection" id="pageBreak-rest">
                        <div className="PackingList-PackingSlipInfo">
                            <div className="container">
                                <div className="row">
                                    <div className="col-sm-12">
                                        <h4 className="text-center">
                                            {this.props.pageText.packingListModalIrisRestrictedPackingSlipTableHead}
                                        </h4>
                                    </div>
                                    <div className="col-sm-6 PackingList-AddressInfo">
                                        <div className="row">
                                            <div className="col-sm-6 text-label">
                                                <p className="text-right">
                                                    <strong>{this.props.pageText.packingListModalIrisRestrictedPackingSlipLabel}</strong>
                                                </p>
                                            </div>
                                            <div className="col-sm-6 text-values">
                                                <p className="text-left">
                                                    {packingList.packingSlipNumber}
                                                </p>
                                            </div>
                                        </div>


                                        <div className="row">
                                            <div className="col-sm-6 text-label">
                                                <p className="text-right">
                                                    <strong>{this.props.pageText.packingListModalDealerCodeLabel}</strong>
                                                </p>
                                            </div>
                                            <div className="col-sm-6 text-values">
                                                <p className="text-left">
                                                    {packingList.dealerCode}
                                                </p>
                                            </div>
                                        </div>

                                        <div className="row">
                                            <div className="col-sm-6 text-label">
                                                <p className="text-right">
                                                    <strong>{this.props.pageText.packingListModalAddressLabel}</strong>
                                                </p>
                                            </div>
                                            <div className="col-sm-6 text-left text-values">
                                                <p>
                                                    {packingList.inventoryTitle}
                                                </p>
                                                <p>
                                                    {packingList.address.addressLineOne}
                                                </p>
                                                <p>
                                                    {packingList.address.city}
                                                    ,{packingList.address.stateCode}
                                                    ,{packingList.address.postalCode}
                                                </p>
                                                <p>
                                                    <strong>
                                                        {packingList.address.phone}
                                                    </strong>
                                                </p>
                                            </div>


                                        </div>

                                    </div>

                                    {!showReturnList

                                        ? <div className="col-sm-6 data-is">
                                            <div className="row text-right">
                                                <div className="col-sm-12">
                                                    <i className="material-icons print text-right"
                                                        onClick={() => this.print()}>
                                                        print
                                                    </i>
                                                </div>
                                            </div>

                                            <div className="row text-right oem-logo">
                                                <div className="col-sm-12">
                                                    <img className="float-right" key="oem-logo" src={oemLogo} title={packingList.oemLogoInformation.alternateText} />
                                                </div>
                                            </div>

                                            <div className="row text-right">
                                                <div className="col-sm-12 text-label">
                                                    <span>
                                                        <strong>{this.props.pageText.packingListModalDealerReferenceLabel}</strong>{packingList.reference}</span>

                                                </div>
                                            </div>
                                        </div>
                                        :
                                        <div className="col-sm-6 data-is scrapListLogo">

                                            <div className="row text-right oem-logo">
                                                <div className="col-sm-12">
                                                    <img key="oem-logo"
                                                        className="float-right"
                                                        title={packingList.oemLogoInformation.alternateText}
                                                        src={oemLogo} />
                                                </div>
                                            </div>

                                            <div className="row text-right">
                                                <div className="col-sm-12 text-label">
                                                    <span>
                                                        <strong>{this.props.pageText.packingListModalDealerReferenceLabel}</strong>{packingList.reference}</span>

                                                </div>
                                            </div>
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>

                        <div>
                            <h4 className="text-center">
                                {this.props.pageText.packingListModalReturnPackingSlipTableHeader}
                            </h4>

                            <BootstrapTable
                                bootstrap4
                                columns={restrictedColumns}
                                condensed
                                data={restrictedList}
                                headerClasses="thead-light"
                                keyField='partNumber'
                                striped
                            />

                            {/* Total for Restricted - hide for IS/IC */}
                            {!isIsuzuUSCA && (
                                <div className="PackingList-ScrapTotal">
                                    <div className="container">
                                        <div className="row">
                                            <div className="col-sm-12 text-right">
                                                <p className="packingfooter-bold">
                                                    {this.props.pageText.packingListModalTotalAmountLabel}
                                                    {' '}
                                                    {restrictedTotal}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}

                            {/* Isuzu US/CA footnote for Restricted slip */}
                            {isIsuzuUSCA && (
                                <div className="PackingList-ScrapTotal">
                                    <div className="container">
                                        <div className="row">
                                            <div className="col-sm-12 text-left">
                                                <p className="returnFooterText">
                                                    {footnoteText}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>

                        <div className="PackingList-ScrapTotal">
                            <div className="container">
                                <div className="row">
                                    <div className="col-sm-12 text-center" >
                                        <span className="packing-footer-one-bold">{this.props.pageText.packingReturnListFooterOneLabel}</span><br />
                                        <span className="packingfooter-bold">{this.props.pageText.packingReturnListFooterTwoLabel}</span>
                                    </div>
                                </div>
                            </div>
                        </div>


                        <hr/>

                    </div>

                    : null}

              

                {/* IRIS Scrap Authorization Packing Slip */}
                {showScrapList
                    ? <div className="PackingList-ScrapListSection pageBreak">
                        <div className="PackingList-PackingSlipInfo">
                            <div className="container">
                                <div className="row">
                                    <div className="col-sm-12">
                                        <h4 className="text-center">
                                            {this.props.pageText.packingListModalIrisScrapPackingSlipTableHeader}
                                        </h4>
                                    </div>   
                                    <div className="col-sm-6 PackingList-AddressInfo">
                                        <div className="row">
                                                <div className="col-sm-6 text-label">
                                                <p className="text-right">
                                                    <strong>{this.props.pageText.packingListModalScarpAuthLabel}</strong>
                                                </p>
                                            </div>
                                            <div className="col-sm-6 text-values">
                                                <p className="text-left">
                                                    {packingList.packingSlipNumber}
                                                </p>
                                            </div>
                                        </div>

                                            <div className="row">
                                                <div className="col-sm-6 text-label">
                                                    <p className="text-right">
                                                        <strong>{this.props.pageText.packingListModalDealerCodeLabel}</strong>
                                                    </p>
                                                </div>
                                                <div className="col-sm-6 text-values">
                                                    <p className="text-left">
                                                        {packingList.dealerCode}
                                                    </p>
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-sm-6 text-label">
                                                    <p className="text-right">
                                                        <strong>{this.props.pageText.packingListModalAddressLabel}</strong>
                                                    </p>
                                                </div>
                                                <div className="col-sm-6 text-left text-values">
                                                    <p>
                                                        {packingList.inventoryTitle}
                                                    </p>
                                                    <p>
                                                        {packingList.address.addressLineOne}
                                                    </p>
                                                    <p>
                                                        {packingList.address.city}
,{packingList.address.stateCode}
,{packingList.address.postalCode}
                                                    </p>
                                                    <p>
                                                        <strong>
                                                            {packingList.address.phone}
                                                        </strong>
                                                    </p>
                                                </div>


                                            </div>

                                        </div>

                                        {!showReturnList

                                            ? <div className="col-sm-6 data-is">
                                                <div className="row text-right">
                                                    <div className="col-sm-12">
                                                        <i className="material-icons print text-right"
                                                            onClick={() => this.print()}>
                                                            print
</i>
                                                    </div>
                                                </div>

                                                <div className="row text-right oem-logo">
                                                    <div className="col-sm-12">
                                                        <img className="float-right" key="oem-logo" src={oemLogo} title={packingList.oemLogoInformation.alternateText} />
                                                    </div>
                                                </div>

                                                <div className="row text-right">
                                                    <div className="col-sm-12 text-label">
                                                        <span>
                                                            <strong>{this.props.pageText.packingListModalDealerReferenceLabel}</strong>{packingList.reference}</span>

                                                    </div>
                                                </div>
                                            </div>
                                            :
                                            <div className="col-sm-6 data-is scrapListLogo">

                                                <div className="row text-right oem-logo">
                                                    <div className="col-sm-12">
                                                        <img key="oem-logo"
                                                            className="float-right"
                                                            title={packingList.oemLogoInformation.alternateText}
                                                            src={oemLogo} />
                                                    </div>
                                                </div>

                                                <div className="row text-right">
                                                    <div className="col-sm-12 text-label">
                                                        <span>
                                                            <strong>{this.props.pageText.packingListModalDealerReferenceLabel}</strong>{packingList.reference}</span>

                                                    </div>
                                                </div>
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>

                            <div className="PackingList-PackingListTable">
                                <h4 className="text-center">
                                    {this.props.pageText.packingListModalIrisScrapAuthTableHeader}
                                </h4>

                                <BootstrapTable
                                    bootstrap4
                                    columns={scrapTableColumns}
                                    condensed
                                    data={packingList.scrapLines}
                                    headerClasses="thead-light"
                                    keyField='partNumber'
                                    striped
                                />

                                {/* Total Scrap Amount - hide for IS/IC */}
                                {!isIsuzuUSCA && (
                                    <div className="PackingList-ScrapTotal">
                                        <div className="container">
                                            <div className="row">
                                                <div className="col-sm-12 text-right">
                                                    <p className="packingfooter-bold">
                                                        {this.props.pageText.packingListModalTotalAmountLabel}
                                                        {' '}
                                                        {scrapTotal}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}

                                {/* Isuzu US/CA footnote for Scrap slip */}
                                {isIsuzuUSCA && (
                                    <div className="PackingList-ScrapTotal">
                                        <div className="container">
                                            <div className="row">
                                                <div className="col-sm-12 text-left">
                                                    <p className="returnFooterText">
                                                        {footnoteText}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>

                        <hr />
                        <div className="PackingList-AgreedTerms">
                            <p>
                                <i className="packingfooter-bold packing-footer-one-bold">{this.props.pageText.packingListModalAgreedTerms1}</i>
                            </p>
                            <p>
                                {this.props.pageText.packingListModalAgreedTerms2}
                            </p>
                            <ul>
                                <li>
                                    {this.props.pageText.packingListModalAgreedTerms3}
                                </li>
                                <li>
                                    {this.props.pageText.packingListModalAgreedTerms4}
                                </li>
                                <li>
                                    {this.props.pageText.packingListModalAgreedTerms5}
                                </li>
                                <li>
                                    {this.props.pageText.packingListModalAgreedTerms6}
                                </li>
                            </ul>
                        </div>

                        <div className="PackingList-SignatureLines">
                            <p>
                                {this.props.pageText.packingListModalSignatureLine1}
                                {' '}
                                <span className="PackingList-AgreedTerms-AuthRep">{this.props.pageText.packingListModalSignatureLine2}</span>:______________________________________________ </p>
                            <p>
                                {this.props.pageText.packingListModalSignatureLine3} ______________________________________________________________</p>
                            <p>
                                {this.props.pageText.packingListModalSignatureLine5}______________________________________________________________________</p>
                            <p>
                                {this.props.pageText.packingListModalSignatureLine4}______________________________________________________________________</p>
                        </div>  

                    </div>

                    : null}
                            

                        </div>)
            ;

        }
        return (
            <div>
                <ModalWindow
                    modalBody={modalBody}
                    modalId="packingList"
                    modalSize="modal-lg"
                    modalTitle={this.props.pageText.packingListModalWindowTitle}
                />
            </div>
        );

    }

}


